<template>
    <div>
        <MainLayout>
            <div v-if="dateChecked" slot="center">
                <div class="d-flex flex-row justify-content-between navigatemenu">
                    <router-link :to="$URLS.vfairsHome" class="navigatemenuitem"
                        >&lt; ALL FAIRS</router-link
                    >
                    <div class="navigatemenuitem">
                        <DateRange :start="vfair.data.start" :end="vfair.data.end"></DateRange>
                    </div>
                </div>
                <div :class="{ mainimagecontainer: true, mainimagecontainernarrow: narrow }">
                    <img class="mainimage" :src="vfair.data.image" />
                    <div
                        class="vfairtitle d-flex flex-column justify-content-center"
                        :class="{ vfairtitlenarrow: narrow }"
                    >
                        <div>{{ vfair.data.title }}</div>
                    </div>
                </div>
                <div class="d-flex flex-wrap justify-content-center mainmenu">
                    <router-link :to="{ name: 'vfair-home' }" class="menubutton homebutton">
                        <div><font-awesome-icon class="mr-2" icon="home" size="lg" />Home</div>
                    </router-link>
                    <router-link :to="{ name: 'vfair-companies' }" class="menubutton">
                        <div>
                            <font-awesome-icon class="mr-2" icon="briefcase" size="lg" />Companies
                        </div>
                    </router-link>
                    <router-link :to="{ name: 'vfair-jobs' }" class="menubutton">
                        <div><font-awesome-icon class="mr-2" icon="bullhorn" size="lg" />Jobs</div>
                    </router-link>
                    <router-link :to="{ name: 'vfair-events' }" class="menubutton">
                        <div>
                            <font-awesome-icon class="mr-2" icon="play-circle" size="lg" />Events
                        </div>
                    </router-link>
                </div>
                <router-view></router-view>
            </div>
        </MainLayout>
        <Footer v-if="dateChecked" slot="center"></Footer>
    </div>
</template>

<script>
import DateRange from '../components/DateRange';
import Footer from '../components/Footer';
import moment from 'moment';
import MainLayout from '../../../components/layouts/mainlayout/MainLayout';

export default {
    name: 'VFair',
    components: {
        MainLayout,
        DateRange,
        Footer,
    },
    data() {
        return {
            companies: [],
            dateChecked: false,
        };
    },
    computed: {
        narrow() {
            return (
                this.$route.name === 'vfair-company' ||
                this.$route.name === 'vfair-events-event' ||
                this.$route.name === 'vfair-jobs-job'
            );
        },
        vfair() {
            if (this.$route.params.id) {
                return this.$interfaces.vfair.id(this.$route.params.id).get({
                    reactive: true,
                });
            } else {
                return { loading: true };
            }
        },
        dateLabel() {
            const startDate = new Date(this.vfair.data.start);
            return startDate.toString();
        },
    },
    methods: {
        checkActiveFair(vfair) {
            const start = moment(vfair.start);
            const end = moment(vfair.end);
            const active = moment().isBetween(start, end);
            if (!active && !localStorage.getItem('vfair_hack')) {
                this.$router.push({ path: '/vfairs/' + vfair.id });
            } else {
                this.dateChecked = true;
            }
        },
    },
    watch: {
        vfair(newValue) {
            if (newValue.loading === false) {
                this.checkActiveFair(newValue.data);
            }
        },
    },
    mounted() {
        if (this.vfair.loading === false) {
            this.checkActiveFair(this.vfair.data);
        }
    },
};
</script>

<style scoped>
.centerlimitwidth {
    max-width: 1160px;
    margin-left: auto;
    margin-right: auto;
    padding: 0 40px;
}

.navigatemenu {
    padding-top: 28px;
    padding-bottom: 9px;
}

.navigatemenuitem {
    text-align: left;
    font: Regular 14px/30px Open Sans;
    letter-spacing: 0px;
    color: #454545;
    text-transform: uppercase;
    opacity: 1;
}

.mainimagecontainer {
    width: 100%;
    padding-top: 27%;
    position: relative; /* If you want text inside of it */
    transition: padding-top 0.2s;
}

.mainimagecontainernarrow {
    padding-top: 87px;
}

.mainimage {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    border-radius: 10px;
    border-width: 5px;
    border-style: solid;
    border-color: var(--primary);
    object-fit: cover;
}

.vfairtitle {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    text-align: center;
    color: #fff;
    font: Regular 25px/30px Open Sans;
    letter-spacing: 0px;
    opacity: 1;
    font-size: 25px;
    transition: font-size 0.2s;
}

.vfairtitlenarrow {
    font-size: 16px;
    padding-top: 22px;
    justify-content: start !important;
}

.mainmenu {
    transform: translateY(-28px);
    z-index: 3;
}

.menubutton {
    width: 159px;
    height: 52px;
    margin: 5px;
    background: #fff;
    color: #000;
    border-radius: 5px;
    text-transform: uppercase;
    font-size: 14px;
    flex-direction: column;
    display: flex;
    justify-content: center;
    text-align: center;
    box-shadow: 0px 0px 25px #00000020;
    text-decoration: none;
    z-index: 3;
}

.menubutton:hover {
    background: #f2f2f2;
}

.router-link-exact-active,
.router-link-active:not(.homebutton) {
    background: var(--primary);
    color: #fff;
}

.router-link-exact-active:hover,
.router-link-active:not(.homebutton):hover {
    background: var(--primary);
    color: #fff;
}

.menubutton a:link {
    text-decoration: none;
}
</style>
